var _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "svg12094062049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.335 16.667)",
    id: "ss12094062049_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.499 66.666 L 22.553 56.613 M 22.553 56.613 C 26.022 60.091 30.735 62.043 35.647 62.037 C 45.875 62.037 54.166 53.746 54.166 43.518 C 54.166 33.291 45.875 25 35.647 25 C 25.42 25 17.129 33.29 17.129 43.518 C 17.122 48.431 19.075 53.144 22.553 56.613 Z",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.165 46.615 C 1.429 41.9 -0.008 36.544 0 31.093 C 0 13.921 13.991 0 31.25 0 L 52.083 0 C 69.343 0 83.333 13.92 83.333 31.093 C 83.333 44.631 74.638 56.148 62.5 60.416",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    fillOpacity: 0
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg12094062049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.df40c312ac32e7ece790826cd267abc6.svg";
export { ForwardRef as ReactComponent };